import { render, staticRenderFns } from "./ResourceBox.vue?vue&type=template&id=be76e28e&scoped=true&"
import script from "./ResourceBox.vue?vue&type=script&lang=js&"
export * from "./ResourceBox.vue?vue&type=script&lang=js&"
import style0 from "./ResourceBox.vue?vue&type=style&index=0&id=be76e28e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be76e28e",
  null
  
)

export default component.exports